var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-base',[_c('tabs',{attrs:{"tabs":_vm.tabs,"disabled":_vm.tabsDisabled},scopedSlots:_vm._u([{key:"default",fn:function({ tab }){return [_c('alarmes-online-list',{attrs:{"filtros":tab.filtros},on:{"atualizando":_vm.atualizando}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }